export default __webpack_public_path__ + "images/10939a002.png";